import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const UnassortedInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Unassorted"
    sectionDisplayName="Unassorted Section"
    backRoute="/sections/unassorted"
  />
);

export default UnassortedInwardConsignment;
